import './UpdateEmailPopUp.scss';
import { Button, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { UpdateEmailPayload } from '../../models/common';
import { useUpdateEmailPopUp } from './useUpdateEmailPopUp';
import AppText from '../AppCommon/AppText/AppText';
import CloseIcon from '@mui/icons-material/Close';
import { useHistoryProvider } from '../../providers/HistoryProvider';
import CircularProgress from '@mui/material/CircularProgress';

interface Props {
    showPopUp: boolean;
    updateEmailPayload: UpdateEmailPayload;
    hidePopUp: () => void;
    setUpdateEmailPayload: Dispatch<SetStateAction<UpdateEmailPayload>>;
    updateEmail: () => void;
}

const UpdateEmailPopUp = ({showPopUp, updateEmailPayload, hidePopUp, setUpdateEmailPayload, updateEmail}: Props) => {
    const {
        emailField,
        handleOnBlur,
        handleOnChange,
        handleOnSave,
        t
    } = useUpdateEmailPopUp({
        updateEmailPayload,
        setUpdateEmailPayload,
        updateEmail
    });
    const historyContext = useHistoryProvider();

    return (
        <Dialog
            className="app-dialog c-update-email-popup"
            disableEscapeKeyDown
            onClose={hidePopUp}
            open={showPopUp}
            maxWidth="lg"
        >
            <DialogTitle>
                <div className="c-header">
                    <IconButton
                        aria-label="close"
                        className="icon-close"
                        onClick={hidePopUp}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent className="dialog-content">
                <div className="c-popup">
                    <div className="label">{t('labels.editInformation')}</div>
                    <AppText
                        label={t('labels.email')}
                        width={50}
                        error={emailField.error || emailField.requiredError ? true : false}
                        helperText={emailField.error || emailField.requiredError}
                        value={emailField.value}
                        onBlur={handleOnBlur}
                        onChange={e => handleOnChange(e)}
                    />
                    <div className="c-btn">
                        <Button
                            className="btn btn--secondary btn-clear"
                            onClick={hidePopUp}
                        >
                            {t('buttons.cancel')}
                        </Button>
                        <Button
                            className="btn btn--primary btn-submit"
                            onClick={handleOnSave}
                            disabled={historyContext.loading.updateEmail}
                        >
                            {historyContext.loading.updateEmail ? <CircularProgress size={20} /> : t('buttons.save')}
                        </Button>
                    </div>
                </div>                
            </DialogContent>
        </Dialog>
    );
};

export default UpdateEmailPopUp;

